export default __webpack_public_path__ + "static/media/alert-illustration.810bf376.webp";